<template>
    <div class="md:bg-white md:px-5 lg:px-7 rounded-b-lg md:pt-4 md:pb-12 rounded-t-lg md:my-4">
        <Title
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <slot />
    </div>
</template>

<script>
import Title from '@/components/text/Title.vue';

export default {
    components: {
        Title,
    },
};
</script>
